<template lang="pug">
    div.mt-8
        div.d-flex.flex-column
            v-text-field.font-weight-bold(
                v-model="newName"
                label="Name"
                autofocus
                :hint="nameSaveable ? '' : 'Note must have a unique name to be saved.'"
                :persistent-hint="true"
                auto-grow
                rows="2"
            )
            v-textarea.pt-6(
                v-model="newContent"
                label="Content"
                :hint="contentSaveable ? '' : 'Note content must be edited to be saved.'"
                :persistent-hint="true"
                auto-grow
                rows="2"
            )
        v-btn(
            v-if="resourceNote"
            small
            @click="handleCancelEdit()"
            style="margin-top: 8px; color: red; margin-right: 8px;"
        ) Cancel
        v-btn(
            v-else
            small
            @click="handleCancelCreate()"
            style="margin-top: 8px; color: red; margin-right: 8px;"
        ) Cancel
        v-btn(
            v-if="resourceNote"
            small
            color="primary"
            :disabled="!noteSaveable"
            @click="handleUpdateResourceNote(resourceNote, newName, newContent)"
            style="margin-top: 8px;"
        ) Save
        v-btn(
            v-else
            small
            color="primary"
            :disabled="!noteSaveable"
            @click="handleCreateResourceNote(newName, newContent)"
            style="margin-top: 8px;"
        ) Save
</template>

<script lang="ts">
    import Vue from 'vue';
    export default Vue.extend({
        data() {
            return {
                newContent: '',
                newName: '',
            }
        },
        methods: {
        },
        computed: {
            nameSaveable() {
                return this.newName != this.resourceNote?.name && !this.existingNoteNames.includes(this.newName.toLowerCase().trim())
            },
            contentSaveable() {
                return this.newContent !== this.resourceNote?.content
            },
            nameAndContentValid() {
                return this.newName.length > 0 && this.newContent.length > 0
            },
            noteSaveable() {
                if (this.resourceNote) {
                    return this.nameAndContentValid && (this.nameSaveable || this.contentSaveable)
                } else {
                    return this.nameAndContentValid && (this.nameSaveable && this.contentSaveable)
                }
            },
        },
        props: {
            resourceNote: Object,
            handleCancelEdit: Function,
            handleCancelCreate: Function,
            handleCreateResourceNote: Function,
            handleUpdateResourceNote: Function,
            existingNoteNames: Array,
        },
        mounted() {
            if (this.resourceNote) {
                this.newContent = this.resourceNote.content;
                this.newName = this.resourceNote.name;
            }
        },
    });
</script>